'use client'

import { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'
import BaseAuthForm from './BaseAuthForm'
import { AuthResult } from '@/types'
import { SignUpFormData } from '@/lib/validations/auth'

type Props = {
  form: UseFormReturn<SignUpFormData>
  onEmailSubmit: (data: SignUpFormData) => Promise<AuthResult | null>
  onGoogleAuth: () => Promise<{ success: boolean; error?: string }>
  onSwitchMode: () => void
}

const SignUpForm: FC<Props> = ({ form, onEmailSubmit, onGoogleAuth, onSwitchMode }) => {
  return (
    <BaseAuthForm
      form={form}
      onEmailSubmit={onEmailSubmit}
      onGoogleAuth={onGoogleAuth}
      authMode="signup"
      onSwitchMode={onSwitchMode}
    />
  )
}

export default SignUpForm
